import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * Site-wide maintenance banner — auto-hides after June 20, 2026.
 * Dismissible per session (sessionStorage).
 */
export default function MaintenanceBanner() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('maintenance_banner_dismissed') === '1');

  // Auto-hide after June 20, 2026 UTC end-of-day
  const expiresAt = new Date('2026-06-20T23:59:59Z');
  if (dismissed || Date.now() > expiresAt.getTime()) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('maintenance_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="w-full relative z-[9999]" style={{ background: 'linear-gradient(90deg, #B45309, #D97706, #B45309)' }}
      data-testid="maintenance-banner">
      <div className="max-w-[1400px] mx-auto px-4 py-2.5 flex items-center gap-3">
        <AlertTriangle className="h-4 w-4 text-yellow-100 shrink-0" />
        <p className="text-[13px] text-yellow-50 flex-1 font-medium leading-snug">
          <strong>Scheduled Maintenance:</strong> Our datacenters will be migrating services from{' '}
          <strong>June 12–20, 2026</strong>. VMs and some Classroom activities may be affected.
          We apologize for any inconvenience.
        </p>
        <button onClick={handleDismiss} className="p-1 rounded-lg hover:bg-white/10 transition-colors shrink-0"
          aria-label="Dismiss maintenance banner" data-testid="dismiss-maintenance-banner">
          <X className="h-4 w-4 text-yellow-100" />
        </button>
      </div>
    </div>
  );
}
